import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroLiquidazioniIvaModalComponent } from './worker-registro-liquidazioni-iva-modal';

export const WorkerRegistroLiquidazioniIvaModalModule: string = ng
    .module('worker-registro-liquidazioni-iva-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroLiquidazioniIvaModalComponent', WorkerRegistroLiquidazioniIvaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-liquidazioni-iva-modal/worker-registro-liquidazioni-iva-modal.module.ts